export default __webpack_public_path__ + "static/1453-6e9345d212246c9ea17b05a285f7eb85.gif";